import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["country", "names", "name"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import phoneMasks from "../utils/phone/phoneMasks";
import { isArray } from "../utils/type";
export var getMaskAsMap = function getMaskAsMap(locale, getOption) {
  return phoneMasks.reduce(function (acc, _ref) {
    var country = _ref.country,
        names = _ref.names,
        name = _ref.name,
        rest = _objectWithoutProperties(_ref, _excluded);

    var newAcc = acc;
    var code = country.toLowerCase();

    if (isArray(country)) {
      country.forEach(function (subCountry) {
        newAcc[subCountry] = getOption(_objectSpread({
          country: subCountry,
          value: code,
          name: names[locale]
        }, rest));
      });
      return newAcc;
    }

    newAcc[code] = getOption(_objectSpread(_objectSpread({
      country: country,
      name: names[locale],
      value: code
    }, rest), acc[code] ? {
      validationsAcc: acc[code].validations
    } : {}));
    return newAcc;
  }, {});
};
export var getLocalByPhoneNumber = function getLocalByPhoneNumber() {
  var phoneNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var phoneMask = phoneMasks.find(function (item) {
    return phoneNumber.replace(/[-,\s,(,),+]/g, '').match(item.test);
  });
  return phoneMask ? phoneMask.country.toLocaleLowerCase() : undefined;
};
export var getDefaultCountryKeys = function getDefaultCountryKeys() {
  return _toConsumableArray(new Set(phoneMasks.map(function (mask) {
    return mask.country.toLowerCase();
  })));
};
export var defaultSort = function defaultSort(a, b) {
  if (a.country.toLowerCase() === 'ru') {
    return -1;
  }

  if (b.country.toLowerCase() === 'ru') {
    return 1;
  }

  if (a.name < b.name) return -1;
  if (a.name > b.name) return 1;
  return 0;
};
export var calculateCursorPosition = function calculateCursorPosition() {
  var newState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _newState$value = newState.value,
      value = _newState$value === void 0 ? '' : _newState$value;

  if (!value) {
    return {
      value: '',
      selection: {}
    };
  }

  var index = value.indexOf('_');
  return {
    value: value,
    selection: {
      start: index,
      end: index
    }
  };
};